import type { FC } from 'react';

import { cn } from '@/lib/utils';

type TWordmarkProps = {
  width?: number;
  className?: string;
};

const NATURAL_WIDTH = 243;
const NATURAL_HEIGHT = 42;
const DEFAULT_WIDTH = 140;

const Wordmark: FC<TWordmarkProps> = ({ width = DEFAULT_WIDTH, className }) => (
  <img
    src="/the500-wordmark.png"
    alt="The 500"
    width={width}
    height={Math.round((width * NATURAL_HEIGHT) / NATURAL_WIDTH)}
    fetchPriority="high"
    className={cn('h-auto', className)}
  />
);

export type {
  TWordmarkProps,
};
export {
  Wordmark,
};
